import Model, { attr, belongsTo, hasMany } from "@ember-data/model";
import { task } from "ember-concurrency";
import { tKey } from "ember-intl";
import { service } from "@ember/service";
import { saveRecord } from "@warp-drive/legacy/compat/builders";

export default class PrivateNetworkModel extends Model {
  @service router;

  @attr name;
  @attr status;

  @belongsTo("project", { async: false, inverse: "privateNetworks" }) project;
  @hasMany("private-network-segment", { async: true, inverse: "privateNetwork" }) segments;

  get isUpdating() {
    return this.status === "UPDATING";
  }

  get isReady() {
    return this.status === "READY";
  }

  get statusIndicator() {
    switch (this.status) {
      case "UPDATING":
        return { state: "busy", showSpinner: true, labelKey: tKey("private-network.status.updating") };
      case "READY":
        return { state: "online", labelKey: tKey("label.online") };
      default:
        return { state: "offline" };
    }
  }

  deletePrivateNetworkTask = task(async () => {
    let privateNetwork = this;

    try {
      privateNetwork.deleteRecord();
      await this.store.request(saveRecord(privateNetwork));
    } catch (error) {
      privateNetwork.rollbackAttributes();
      throw error;
    }

    this.router.transitionTo("private-networks.overview");
  });

  updateTask = task(async (name) => {
    this.name = name;
    this.store.request(saveRecord(this));
  });
}
